import { getSonarObjectApplications } from '@api';
import { updateApplicationReferences } from '../../data-security/applications/_idMap/actions';
import { updateSonarObjectReferences } from '../_idMap/actions';

import { createGetAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const getCoreSonarObjectsApplicationsAsyncSlice = createGetAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request, response) =>
				updateSonarObjectReferences([
					{
						ingestedBy: response.results
							.filter((entry) => entry.read)
							.map((entry) => entry.integratedAppId),
						populatedBy: response.monitored ?
							response.results
								.filter((entry) => entry.write)
								.map((entry) => entry.integratedAppId) :
							[ -1 ],
						sonarObjectId: request.sonarObjectId
					}
				])
		],
		successDataActionCreators: [
			(response) =>
				updateApplicationReferences(
					response.results.map((entry) => ({
						applicationId: entry.integratedAppId,
						label: entry.label,
						name: entry.name
					}))
				)
		]
	},
	name: 'CoreSonarObjectsApplications',
	receive: true,
	request: true,
	requestHandler: getSonarObjectApplications,
	yieldType: SagaYieldType.Every
});
